import { useEffect, useRef } from 'react';

// Calls onClose when ESC is pressed while `active`. Stashes the latest onClose in a ref
// so the document listener is bound exactly once per active-toggle, regardless of caller
// re-renders. We deliberately do NOT stopPropagation — at the document level it can't
// reach earlier-registered listeners, and stopping it would silently break global
// shortcut handlers in nested overlays.
export function useEscapeClose(active: boolean, onClose: () => void): void {
  const cbRef = useRef(onClose);
  useEffect(() => {
    cbRef.current = onClose;
  });
  useEffect(() => {
    if (!active) return;
    function handleKey(e: KeyboardEvent): void {
      if (e.key === 'Escape') cbRef.current();
    }
    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [active]);
}
